// Membership Page
export default function Membership() { return <div><h1 className="text-4xl font-bold text-center py-20">Membership</h1></div>; }